import { SET_PANEL, SET_LOADING_MAP, SET_ACTION_MAP, SET_CONFIG_MAP } from './mutation-types';
import {isObject} from '@config/utils'

const mutations = {
    [SET_PANEL](state, {id, ...params}) {
        let panel = null;
        let tools = state.data.tools;
        if(tools[id]){
            panel = tools[id].panel;
        }
        if(!panel){
            return;
        }
        for (var key in params) {
            if(['active', 'show', 'loaded'].includes(key)){
                params[key] = !!params[key];
            }
            if (panel.hasOwnProperty(key) && params[key] !== undefined) {
                if(isObject(panel[key]) && isObject(params[key])){
                    panel[key] = {...panel[key], ...params[key]};
                }else{
                    panel[key] = params[key];
                }
            }
        }
    },
    [SET_LOADING_MAP](state, flag) {
        state.data.map.loading = flag;
    },
    [SET_ACTION_MAP](state, action) {
        state.data.map.action = action;
    },
    [SET_CONFIG_MAP](state, config) {
        state.data.map.config = Object.assign(state.data.map.config, config);
    },
};

export default mutations;
